import React from "react";
import { FormGroup } from "react-bootstrap";
import Label from "../Label/Label";
import Input from "../Input/Input";
import InputError from "../InputError/InputError";

function FormCheckbox(props) {
  const {
    label,
    error,
    errorClassName,
    id,
    name,
    type,
    className,
    value,
    disabled,
    onChange,
    minLength,
    maxLength,
    checked,
    placeHolder,
    multiple,
    accept,
  } = props;

  return (
    // <FormGroup>
    <label className="checkbox checkbox-primary mb-3">
      <Input
        id={id}
        name={name}
        type={type}
        className={className}
        value={value}
        disabled={disabled}
        onChange={onChange}
        minLength={minLength}
        maxLength={maxLength}
        checked={checked}
        placeHolder={placeHolder}
        multiple={multiple}
        accept={accept}
      />
      <span> {label}</span>
      <span className="checkmark" />

      <InputError error={error} className={errorClassName} />
    </label>
    // </FormGroup>
  );
}

export default FormCheckbox;
